import {
  shouldRedirectArMembershipToHome,
  stripIntlSeoFunnelQuery,
} from "@/lib/arIntlSeoFunnelRedirect";
import { MEMBERSHIP_LANDING_PATH_ES } from "@/lib/membershipLandingPath";
import { usesSpanishDefaultForSite } from "@/lib/siteGeoPolicy";
import type { To } from "react-router-dom";

/**
 * Superficies que muestran TemplateLoadingScreen durante un redirect SPA.
 *
 * | Surface | Dónde | Primer paint después |
 * |---------|-------|----------------------|
 * | ar-intl-seo-funnel | MembershipLandingRoute, DualCTAVideoLanding | Index (useLoadingGate) |
 * | membership-locale-alias | MembershipLandingRoute /membership→/ser-miembro | DualCTAVideoLanding |
 * | ar-invitation-premium | DualCTAVideoLanding /invitacion-premium | Index |
 * | country-landing-ar-home | IntlSeoLandingGate (worker geo) → AR en landings SEO intl | Index (BaseTemplate) |
 * | app-i18n-boot | App I18nLoadingWrapper | cualquier ruta |
 * | index-template-assets | Index useLoadingGate | BaseTemplate home |
 */
export type RedirectLoadingReason =
  | "ar-intl-seo-funnel"
  | "ar-membership-blocked"
  | "membership-locale-alias"
  | "ar-invitation-premium"
  | "country-landing-ar-home";

export type RedirectLoadingTarget = {
  reason: RedirectLoadingReason;
  to: To;
};

export function resolveMembershipRouteRedirect(options: {
  pathname: string;
  search: string;
  hash: string;
  locale: "es" | "intl";
  isPreview: boolean;
}): RedirectLoadingTarget | null {
  if (options.isPreview) return null;

  // AR prohibido en el funnel membership completo (no solo con query intl
  // SEO). Paridad con el worker resolveMembershipLandingRedirect.
  if (
    shouldRedirectArMembershipToHome({
      pathname: options.pathname,
      search: options.search,
    })
  ) {
    return {
      reason: "ar-membership-blocked",
      to: {
        pathname: "/",
        search: stripIntlSeoFunnelQuery(options.search),
        hash: options.hash,
      },
    };
  }

  if (options.locale === "intl" && usesSpanishDefaultForSite()) {
    return {
      reason: "membership-locale-alias",
      to: `${MEMBERSHIP_LANDING_PATH_ES}${options.search}${options.hash}`,
    };
  }

  return null;
}